import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Volver a inicio
        </Link>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Política de Privacidad</h1>
        
        <div className="prose prose-gray max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Responsable del Tratamiento</h2>
            <p className="text-gray-600">
              <strong>Identidad:</strong> Eye Star S.L.<br />
              <strong>CIF:</strong> B87171740<br />
              <strong>Dirección:</strong> Avenida de la Industria 16, Tres Cantos (Madrid)<br />
              <strong>Email:</strong> reservas@hotel-martorell.es
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Finalidad del Tratamiento</h2>
            <p className="text-gray-600">
              Los datos personales que nos facilite serán tratados con las siguientes finalidades:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Gestionar las solicitudes de información sobre nuestros hoteles y servicios.</li>
              <li>Enviar comunicaciones comerciales sobre ofertas, promociones y novedades de nuestros establecimientos.</li>
              <li>Gestionar reservas y servicios contratados.</li>
              <li>Dar respuesta a las consultas planteadas.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Legitimación</h2>
            <p className="text-gray-600">
              La base legal para el tratamiento de sus datos es:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>El consentimiento del interesado para el envío de comunicaciones comerciales.</li>
              <li>La ejecución de un contrato para la gestión de reservas.</li>
              <li>El interés legítimo para responder a consultas.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Destinatarios</h2>
            <p className="text-gray-600">
              No se cederán datos a terceros, salvo obligación legal. Podrán tener acceso a sus datos los encargados del tratamiento necesarios para la prestación de servicios (hosting, email marketing, etc.).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Derechos del Interesado</h2>
            <p className="text-gray-600">
              Puede ejercer sus derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición enviando un email a <a href="mailto:reservas@hotel-martorell.es" className="text-blue-600 hover:underline">reservas@hotel-martorell.es</a>.
            </p>
            <p className="text-gray-600 mt-2">
              También tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Conservación de Datos</h2>
            <p className="text-gray-600">
              Los datos se conservarán mientras dure la relación comercial y durante el plazo de prescripción de las posibles responsabilidades legales.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">7. Seguridad</h2>
            <p className="text-gray-600">
              Hemos adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de sus datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado.
            </p>
          </section>
        </div>

        <p className="text-sm text-gray-500 mt-8">
          Última actualización: Febrero 2026
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
